export default __webpack_public_path__ + "static/media/Boy.171e3140.png";